"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.blockchainConfigMap = void 0;
const Enums_1 = require("../Types/Enums");
const Avalanche_1 = require("./Avalanche");
const Binance_1 = require("./Binance");
const BinanceTestnet_1 = require("./BinanceTestnet");
const BTTC_1 = require("./BTTC");
const Ethereum_1 = require("./Ethereum");
const EthereumRinkeby_1 = require("./EthereumRinkeby");
const Harmony_1 = require("./Harmony");
const Iotex_1 = require("./Iotex");
const OntologyTestnet_1 = require("./OntologyTestnet");
const Ontology_1 = require("./Ontology");
const Polygon_1 = require("./Polygon");
const FTM_1 = require("./FTM");
const Tron_1 = require("./Tron");
const EthereumGoerli_1 = require("./EthereumGoerli");
exports.blockchainConfigMap = {
    [Enums_1.Blockchains.Ethereum]: Ethereum_1.EthereumConfig,
    [Enums_1.Blockchains.EthereumGoerli]: EthereumGoerli_1.EthereumGoerliConfig,
    [Enums_1.Blockchains.EthereumRinkeby]: EthereumRinkeby_1.EthereumRinkebyConfig,
    [Enums_1.Blockchains.Binance]: Binance_1.BinanceConfig,
    [Enums_1.Blockchains.BinanceTestnet]: BinanceTestnet_1.BinanceTestnetConfig,
    [Enums_1.Blockchains.Harmony]: Harmony_1.HarmonyConfig,
    [Enums_1.Blockchains.Avalanche]: Avalanche_1.AvalancheConfig,
    [Enums_1.Blockchains.Polygon]: Polygon_1.PolygonConfig,
    [Enums_1.Blockchains.Iotex]: Iotex_1.IotexConfig,
    [Enums_1.Blockchains.BTTC]: BTTC_1.BttcConfig,
    [Enums_1.Blockchains.OntologyTestnet]: OntologyTestnet_1.OntologyTestnetConfig,
    [Enums_1.Blockchains.FTM]: FTM_1.FTMConfig,
    [Enums_1.Blockchains.Tron]: Tron_1.TronConfig,
    [Enums_1.Blockchains.Ontology]: Ontology_1.OntologyConfig,
};
